export default function qtyUI() {
	initQtySelectors();
};

const initQtySelectors = () => {
	$('.js-qty').each(function() {
		const $container = $(this);
		const $incButton = $container.find('.js-qty-increase');
		const $decButton = $container.find('.js-qty-decrease');
		const $field = $container.find('.js-qty-field');
		const min = $field.data('min');
		const max = $field.data('max') ? $field.data('max') : 9999;
		const $mimicTarget = $($container.data('mimic'));

		$incButton.on('click', function() {
			const currentVal = Number($field.val());

			if ( max > currentVal ) {
				$field.val(currentVal + 1).trigger('change');

				update(currentVal + 1);
			}
		});

		$decButton.on('click', function() {
			const currentVal = Number($field.val());

			if ( min < currentVal ) {
				$field.val(currentVal - 1).trigger('change');

				update(currentVal - 1);
			}
		});

		function update(val) {
			let labelText;
			if (Number(val) === 1) {
				labelText = $container.data('default');
			} else {
				labelText = $container.data('plural');
			}

			$mimicTarget.text(val + ' ' + labelText);
		}

		$field.on('change.bmprefill', (e) => {
			const value = Number(e.target.value);
			$field.val(value);
			update(value);
		});
	});
}
